import { useEffect } from "react";
import { useAutoSignin } from "react-oidc-context";
import { useAuth, hasAuthParams } from "react-oidc-context";

import { buildRedirectUri } from "./redirectUri";

const Unauthenticated = ({ children }) => {
  // https://github.com/authts/react-oidc-context/blob/f82bee325f3a58c56b2ccc1e7e3333f992b88c18/src/useAutoSignin.ts#L10
  useAutoSignin({
    signinArgs: {
      redirect_uri: buildRedirectUri(),
    },
  });

  const { isAuthenticated, error, isLoading, activeNavigator, signinRedirect } =
    useAuth();

  if (isAuthenticated || isLoading || error) {
    return null;
  }

  return children;
};

export default Unauthenticated;
